import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';

const DownloadPage = () => {
  const { versionId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Flag to prevent duplicate download requests
    let isDownloadInitiated = false;

    const initiateDownload = async () => {
      if (isDownloadInitiated) return;
      isDownloadInitiated = true;
      
      try {
        // First, initiate the download
        const response = await fetch(`${process.env.REACT_APP_API_URL}/downloads/start`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ versionId })
        });

        if (!response.ok) {
          throw new Error('Failed to start download');
        }

        const data = await response.json();
        
        // Verify we have a valid download URL
        if (!data.downloadUrl) {
          throw new Error('Invalid download URL received');
        }

        // Create a temporary link and click it
        const link = document.createElement('a');
        link.href = data.downloadUrl;
        link.setAttribute('download', ''); // This will force download
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Navigate back after a short delay
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } catch (error) {
        console.error('Download error:', error);
        setError('Failed to download file. Please try again.');
        isDownloadInitiated = false; // Reset flag on error to allow retry
      } finally {
        setLoading(false);
      }
    };

    initiateDownload();
    
    // Cleanup function
    return () => {
      isDownloadInitiated = true; // Prevent download if component unmounts and remounts
    };
  }, [versionId, navigate]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Typography>Downloading file...</Typography>
    </Box>
  );
};

export default DownloadPage;